import React, { useEffect, useRef } from 'react'
import { ContentGrid, SummaryPicture } from '../../../partials/ContentGrid'
import { FormattedMessage } from 'react-intl'
import { Link } from '../../../utils/helpers'
import Button from '../../../components/Button/Button'
import { Color, Direction } from '../../../utils/constants'
import SectionWithTag, { Side } from '../../../components/SectionWithTag'
import { SetPaddingProps } from '../../../utils/PaddingContext'
import { useIsMobile } from '../../../utils/helpers'

const id = 'page.about.us'

const Intro = ({ setPadding }: SetPaddingProps) => {
    const leftRef = useRef<HTMLDivElement>(null)
    const rightRef = useRef<HTMLDivElement>(null)
    const contentRef = useRef<HTMLDivElement>(null)
    const isMobile = useIsMobile()
    useEffect(() => {
        const calculatePadding = () => {
            requestAnimationFrame(() => {
                if (leftRef.current && rightRef.current && contentRef.current && !isMobile) {
                    const pad = {
                        paddingLeft:
              leftRef.current.getBoundingClientRect().left -
              contentRef.current.getBoundingClientRect().left,
                        paddingRight:
              window.innerWidth -
              rightRef.current.getBoundingClientRect().right -
              contentRef.current.getBoundingClientRect().left,
                    }
                    setPadding(pad)
                } else {
                    setPadding()
                }
            })
        }
        calculatePadding()
        window.addEventListener('resize', calculatePadding)
        return () => {
            window.removeEventListener('resize', calculatePadding)
        }
    }, [leftRef, rightRef, isMobile, contentRef])
    return (
        <div className='border-b border-black/10'>
            <ContentGrid className='3xl:max-w-screen-2xl mx-auto'>
                <div className='aspect-auto md:py-16' ref={contentRef}>
                    <SectionWithTag
                        tag={{ id: `${id}.tag` }}
                        className='content-grid--tag-small'
                        side={Side.LEFT}
                    >
                        <div className='pt-9 md:pt-16 md:py-2 bg-white flex flex-col items-center order-2 md:order-1'>
                            <div className='max-w-[520px] flex flex-col gap-y-8' ref={leftRef}>
                                <FormattedMessage id={id} tagName='h2' />
                                <div className='max-w-[410px]'>
                                    <FormattedMessage id={`${id}.description`} tagName='p' />
                                </div>
                                <Link to='/technology'>
                                    <Button
                                        isInverted
                                        buttonColor={Color.PURPLE}
                                        chevron={Direction.RIGHT}
                                        outerClasses='w-max'
                                    >
                                        <FormattedMessage id={`${id}.learnMore`} tagName='h6' />
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </SectionWithTag>
                </div>
                <div className='md:p-[15%] aspect-auto'>
                    <div ref={rightRef} className='h-full'>
                        <SummaryPicture
                            slug='team-2026'
                            className='order-1 md:order-2'
                            imageClassName='aspect-auto'
                        />
                    </div>
                </div>
            </ContentGrid>
        </div>
    )
}

export default Intro
